/* HVAC-AI-053 */
(function () {
  const WIZARD_ID = 'collection-filter-wizard';
  const I18N_ID = 'collection-filter-wizard-i18n';
  const STORAGE_KEY = 'hvac-collection-filter-wizard';
  const PRESELECT_GOODMAN_KEY = 'hvac-wizard-preselect-goodman';
  const EXCLUDED_MERGE_FILTER_PARAMS = new Set([
    'filter.v.price.gte',
    'filter.v.price.lte',
    'filter.p.vendor',
  ]);
  const EXCLUDED_URL_PARAMS = new Set(['wizard', 'goodman']);

  function getWizardRoot() {
    return document.getElementById(WIZARD_ID);
  }

  function getWizardSteps(root) {
    return Array.from(root.querySelectorAll('.collection-filter-wizard__step'));
  }

  function getStepCards(stepEl) {
    return Array.from(stepEl.querySelectorAll('.custom-filter-card'));
  }

  function readCardSelection(card) {
    return {
      param: card.dataset.filterParam,
      value: card.dataset.filterValue,
    };
  }

  function setCardActive(card, isActive) {
    card.dataset.isActive = isActive ? 'true' : 'false';
    card.classList.toggle('active', isActive);
    card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  }

  function setCardUnavailable(card, isUnavailable) {
    card.classList.toggle('is-unavailable', isUnavailable);
    card.disabled = isUnavailable;
    card.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
  }

  function selectCardInGroup(card) {
    const group = card.closest('.custom-filter-cards');
    if (!group) return;
    getStepCards(group).forEach((c) => setCardActive(c, c === card));
  }

  function canRenderCollectionViaFacets() {
    return (
      typeof FacetFiltersForm !== 'undefined' &&
      typeof FacetFiltersForm.renderPage === 'function' &&
      document.getElementById('product-grid') &&
      document.getElementById('ProductGridContainer')
    );
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function closeMobileFacetsDrawer() {
    const drawer = document.querySelector('menu-drawer.mobile-facets__wrapper[data-breakpoint="mobile"]');
    if (!drawer) return;

    drawer.querySelectorAll('details').forEach((details) => {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');

      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });

    drawer.querySelectorAll('.submenu-open').forEach((element) => {
      element.classList.remove('submenu-open');
    });
  }

  function unlockPageScroll() {
    closeMobileFacetsDrawer();
    document.body.classList.remove(
      'collection-filter-wizard-open',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden'
    );
  }

  function getStickyHeaderOffset() {
    const header =
      document.querySelector('.section-header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('header.header');

    if (!header) return 0;
    return Math.ceil(header.getBoundingClientRect().height);
  }

  function readI18n() {
    const el = document.getElementById(I18N_ID);
    const fallback = {
      previousStep: 'Back',
      nextStep: 'Next step',
      nextStepNamed: 'Next: __STEP__',
      skipViewAll: 'Skip & view all',
      compatibleCountOne: '__COUNT__ compatible product',
      compatibleCountOther: '__COUNT__ compatible products',
      compatibleCountLoading: 'Checking compatible products…',
      optionsLoading: 'Loading available options…',
      optionsEmpty: 'No options match your current selections.',
      selectionGoToStep: 'Go to __STEP__ step',
    };
    if (!el) return fallback;
    try {
      return { ...fallback, ...JSON.parse(el.textContent) };
    } catch (e) {
      return fallback;
    }
  }

  function formatCountLabel(template, count) {
    return template.replace(/__COUNT__|\{\{\s*count\s*\}\}/g, String(count));
  }

  function parseProductCount(text) {
    if (!text) return null;
    const match = text.replace(/,/g, '').match(/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  }

  function debounce(fn, delay) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  }

  function getActiveCardForStep(stepEl) {
    return getStepCards(stepEl).find((card) => card.classList.contains('active')) || null;
  }

  function getSelectedCardForStep(stepEl, pending) {
    const activeCard = getActiveCardForStep(stepEl);
    if (activeCard) return activeCard;

    return (
      getStepCards(stepEl).find((card) => {
        const { param, value } = readCardSelection(card);
        return param && pending.get(param) === value;
      }) || null
    );
  }

  function appendSelectionLine(container, text) {
    if (!text) return;
    const line = document.createElement('span');
    line.className = 'collection-filter-wizard__selection-line';
    line.textContent = text;
    container.appendChild(line);
  }

  function cleanFacetSummaryLabel(text) {
    if (!text) return '';
    return text.replace(/\s*\([^)]*\)\s*$/g, '').replace(/\s+/g, ' ').trim();
  }

  function buildTextSelectionValue(text) {
    const valueEl = document.createElement('div');
    valueEl.className = 'collection-filter-wizard__selection-value';
    appendSelectionLine(valueEl, text);
    return valueEl;
  }

  function buildSelectionValue(activeCard) {
    const valueEl = document.createElement('div');
    valueEl.className = 'collection-filter-wizard__selection-value';

    const logo = activeCard.querySelector('.custom-filter-card__logo');
    if (logo) {
      const logoClone = logo.cloneNode(true);
      logoClone.className = 'collection-filter-wizard__selection-logo';
      logoClone.removeAttribute('width');
      logoClone.removeAttribute('height');
      valueEl.appendChild(logoClone);
      return valueEl;
    }

    if (activeCard.classList.contains('custom-filter-card--icon')) {
      const icon = activeCard.querySelector('.custom-filter-card__icon img');
      if (icon) {
        const iconClone = icon.cloneNode(true);
        iconClone.className = 'collection-filter-wizard__selection-icon';
        iconClone.removeAttribute('width');
        iconClone.removeAttribute('height');
        valueEl.appendChild(iconClone);
      }
      appendSelectionLine(
        valueEl,
        activeCard.querySelector('.custom-filter-card__label-top')?.textContent?.trim()
      );
      return valueEl;
    }

    if (activeCard.classList.contains('custom-filter-card--flow-direction')) {
      const flowImage = activeCard.querySelector('.custom-filter-card__flow-image img');
      if (flowImage) {
        const flowImageClone = flowImage.cloneNode(true);
        flowImageClone.className = 'collection-filter-wizard__selection-flow-image';
        flowImageClone.removeAttribute('width');
        flowImageClone.removeAttribute('height');
        valueEl.appendChild(flowImageClone);
      }

      appendSelectionLine(
        valueEl,
        activeCard.querySelector('.custom-filter-card__label-top')?.textContent?.trim()
      );
      return valueEl;
    }

    if (activeCard.classList.contains('custom-filter-card--tonnage')) {
      appendSelectionLine(
        valueEl,
        activeCard.querySelector('.custom-filter-card__label-top')?.textContent?.trim()
      );
      appendSelectionLine(
        valueEl,
        activeCard.querySelector('.custom-filter-card__label-bottom')?.textContent?.trim()
      );
      return valueEl;
    }

    if (
      activeCard.classList.contains('custom-filter-card--seer') ||
      activeCard.classList.contains('custom-filter-card--efficiency')
    ) {
      appendSelectionLine(
        valueEl,
        activeCard.querySelector('.custom-filter-card__label-top')?.textContent?.trim()
      );
      appendSelectionLine(
        valueEl,
        activeCard.querySelector('.custom-filter-card__label-bottom')?.textContent?.trim()
      );
      appendSelectionLine(
        valueEl,
        activeCard.querySelector('.custom-filter-card__label-detail')?.textContent?.trim()
      );
      return valueEl;
    }

    appendSelectionLine(
      valueEl,
      activeCard.querySelector('.custom-filter-card__label-top')?.textContent?.trim()
    );
    return valueEl;
  }

  function appendSelectionListItem(listEl, valueEl, labelText, modifierClass, options = {}) {
    const item = document.createElement('li');
    item.className = 'collection-filter-wizard__selection-item';
    if (modifierClass) item.classList.add(modifierClass);

    const labelEl = document.createElement('span');
    labelEl.className = 'collection-filter-wizard__selection-label';
    labelEl.textContent = labelText;

    if (typeof options.stepIndex === 'number') {
      item.classList.add('collection-filter-wizard__selection-item--step');

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'collection-filter-wizard__selection-trigger';
      button.dataset.wizardSelectionStep = String(options.stepIndex);
      if (options.ariaLabel) {
        button.setAttribute('aria-label', options.ariaLabel);
      }
      button.appendChild(valueEl);
      button.appendChild(labelEl);
      item.appendChild(button);
    } else {
      item.appendChild(valueEl);
      item.appendChild(labelEl);
    }

    listEl.appendChild(item);
  }

  function getBrandStepIndex(steps) {
    let index = steps.findIndex((step) => step.querySelector('.custom-filter-cards--brand'));
    if (index >= 0) return index;

    return steps.findIndex((step) => {
      const key = (step.dataset.filterKey || '').toLowerCase();
      const label = (step.dataset.filterLabel || '').toLowerCase();
      return key === 'brand' || label === 'brand' || label.includes('brand');
    });
  }

  function findGoodmanBrandCard(step) {
    return getStepCards(step).find((card) => {
      if (card.classList.contains('custom-filter-card--brand-goodman')) return true;

      const { value } = readCardSelection(card);
      if (String(value || '').toLowerCase().includes('goodman')) return true;

      const ariaLabel = (card.getAttribute('aria-label') || '').toLowerCase();
      if (ariaLabel.includes('goodman')) return true;

      const brandLogo = card.querySelector('.custom-filter-card__brand-mark img');
      if (brandLogo && /goodman/i.test(brandLogo.getAttribute('src') || '')) return true;

      return false;
    });
  }

  function shouldPreselectGoodman(wizard) {
    return (
      wizard.root.dataset.preselectGoodman === '1' ||
      sessionStorage.getItem(PRESELECT_GOODMAN_KEY) === window.location.pathname
    );
  }

  function setPreselectGoodmanIntent(wizard) {
    wizard.root.dataset.preselectGoodman = '1';
    sessionStorage.setItem(PRESELECT_GOODMAN_KEY, window.location.pathname);
  }

  function clearPreselectGoodmanIntent(wizard) {
    if (wizard?.root) wizard.root.dataset.preselectGoodman = '';
    sessionStorage.removeItem(PRESELECT_GOODMAN_KEY);
  }

  function preselectGoodmanBrand(wizard) {
    const brandStepIndex = getBrandStepIndex(wizard.steps);
    if (brandStepIndex < 0) return false;

    const step = wizard.steps[brandStepIndex];
    const goodmanCard = findGoodmanBrandCard(step);
    if (!goodmanCard) return false;

    const { param, value } = readCardSelection(goodmanCard);
    if (!param || value == null) return false;

    setCardUnavailable(goodmanCard, false);
    wizard.pending.set(param, value);
    selectCardInGroup(goodmanCard);
    wizard.syncMaxStepReachedFromSelections();
    return true;
  }

  function stripWizardLaunchParams() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('wizard') && !url.searchParams.has('goodman')) return;

    url.searchParams.delete('wizard');
    url.searchParams.delete('goodman');

    const query = url.searchParams.toString();
    const nextUrl = `${url.pathname}${query ? `?${query}` : ''}${url.hash}`;
    window.history.replaceState({}, '', nextUrl);
  }

  /* HVAC-064-AB — collections without wizard fall back to vendor filter */
  function redirectToGoodmanVendorFilter() {
    const url = new URL(window.location.href);
    url.searchParams.delete('wizard');
    url.searchParams.delete('goodman');
    url.searchParams.delete('filter.p.vendor');
    url.searchParams.append('filter.p.vendor', 'Goodman');
    const query = url.searchParams.toString();
    window.location.replace(`${url.pathname}${query ? `?${query}` : ''}${url.hash}`);
  }

  function maybeFallbackGoodmanVendorFilter() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('wizard') !== 'open') return;
    if (urlParams.get('goodman') !== '1' && urlParams.get('goodman') !== 'true') return;
    if (getWizardRoot()) return;
    redirectToGoodmanVendorFilter();
  }

  function maybeAutoOpenWizard(wizard) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('wizard') !== 'open') return;
    if (wizard.root.dataset.wizardAutoOpened === 'true') return;
    wizard.root.dataset.wizardAutoOpened = 'true';

    const shouldPreselect =
      urlParams.get('goodman') === '1' || urlParams.get('goodman') === 'true';
    const brandStepIndex = getBrandStepIndex(wizard.steps);

    /* HVAC-064-AB — wizard present but no brand step: same as no-wizard fallback */
    if (shouldPreselect && brandStepIndex < 0) {
      redirectToGoodmanVendorFilter();
      return;
    }

    let openStep = 0;

    /* HVAC-064-AB — Goodman LP control: brand pre-selected, open on step 2 */
    if (shouldPreselect && brandStepIndex >= 0) {
      const nextStepAfterBrand = brandStepIndex + 1;
      openStep =
        nextStepAfterBrand < wizard.steps.length ? nextStepAfterBrand : brandStepIndex;
      setPreselectGoodmanIntent(wizard);
    }

    wizard.open(openStep, { preselectGoodman: shouldPreselect });
    stripWizardLaunchParams();
  }

  class CollectionFilterWizard {
    constructor(root) {
      this.root = root;
      this.steps = getWizardSteps(root);
      this.currentStep = 0;
      this.maxStepReached = 0;
      this.pending = new Map();
      this.i18n = readI18n();

      this.stepperList = root.querySelector('.collection-filter-wizard__stepper-list');
      this.footerEl = root.querySelector('.collection-filter-wizard__footer');
      this.selectionEl = root.querySelector('[data-wizard-selection]');
      this.selectionListEl = root.querySelector('[data-wizard-selection-list]');
      this.selectionCountEl = root.querySelector('[data-wizard-selection-count]');
      this.selectionToggle = root.querySelector('[data-wizard-selection-toggle]');
      this.prevBtn = root.querySelector('[data-wizard-prev]');
      this.viewCompatibleBtn = root.querySelector('[data-wizard-view-compatible]');
      this.nextBtn = root.querySelector('[data-wizard-next]');
      this.applyBtn = root.querySelector('[data-wizard-apply]');
      this.prevLabelEl = root.querySelector('[data-wizard-prev-label]');
      this.nextLabelEl = root.querySelector('[data-wizard-next-label]');
      this.closeButtons = root.querySelectorAll('[data-wizard-close]');
      this.dialogEl = root.querySelector('.collection-filter-wizard__dialog');
      this.countFetchAbortController = null;
      this.countFetchRequestId = 0;
      this.availabilityFetchRequestId = 0;
      this._availabilityRenderer = null;
      this.previousStepIndex = null;
      this.scheduleCompatibleCountFetch = debounce(() => this.fetchCompatibleCount(), 300);
      this.scheduleCardAvailabilityUpdate = debounce(() => this.refreshStepOptions(), 300);

      this.buildStepper();
      this.bindEvents();
      this.syncFromAppliedFilters();
      this.renderStep();
      maybeAutoOpenWizard(this);
    }

    syncFromAppliedFilters(options = {}) {
      this.pending.clear();
      this.seedPendingFromUrl();

      if (options.preselectGoodman || shouldPreselectGoodman(this)) {
        sessionStorage.removeItem(STORAGE_KEY);
        preselectGoodmanBrand(this);
      } else {
        this.restoreFromStorage();
        this.syncCardsFromPending();
      }

      this.syncMaxStepReachedFromSelections();
    }

    handleCardClick(card) {
      if (card.classList.contains('is-unavailable') || card.disabled) return;

      const { param, value } = readCardSelection(card);
      const wasActive =
        card.classList.contains('active') ||
        (param && value != null && this.pending.get(param) === value);

      if (wasActive) {
        const group = card.closest('.custom-filter-cards');
        if (group) {
          getStepCards(group).forEach((c) => setCardActive(c, false));
        } else {
          setCardActive(card, false);
        }
        if (param) this.pending.delete(param);
      } else {
        selectCardInGroup(card);
        if (param) this.pending.set(param, value);
      }

      this.updateNextButtonState();
      this.updateSelectionSummary();
      this.persistState();
      this.syncMaxStepReachedFromSelections();
      this.updateStepper();
      this.clearSelectionsAfterStep(this.currentStep);
    }

    syncCardsFromPending() {
      this.steps.forEach((step) => {
        getStepCards(step).forEach((card) => setCardActive(card, false));
      });

      this.pending.forEach((value, param) => {
        this.steps.forEach((step) => {
          getStepCards(step).forEach((card) => {
            const selection = readCardSelection(card);
            if (selection.param === param && selection.value === value) {
              selectCardInGroup(card);
            }
          });
        });
      });
    }

    syncMaxStepReachedFromSelections() {
      let max = this.currentStep;

      this.steps.forEach((step, index) => {
        if (this.hasStepSelection(index)) {
          max = Math.max(max, index);
        }
      });

      this.maxStepReached = max;
    }

    persistState() {
      if (!this.pending.size) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }

      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          pathname: window.location.pathname,
          pending: Array.from(this.pending.entries()),
        })
      );
    }

    restoreFromStorage() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return;

        const parsed = JSON.parse(raw);
        if (!parsed || parsed.pathname !== window.location.pathname || !Array.isArray(parsed.pending)) return;

        parsed.pending.forEach(([param, value]) => {
          if (!param || value == null || this.pending.has(param)) return;
          this.pending.set(param, value);
        });
      } catch (error) {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    }

    scrollToProductGrid() {
      const grid =
        document.getElementById('ProductGridContainer') ||
        document.querySelector('.product-grid-wrapper') ||
        document.getElementById('product-grid');

      if (!grid) return;

      const runScroll = () => {
        const offset = getStickyHeaderOffset();
        const top = Math.max(0, window.scrollY + grid.getBoundingClientRect().top - offset - 12);

        window.scrollTo({
          top,
          behavior: isMobileViewport() ? 'auto' : 'smooth',
        });
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(runScroll);
      });
    }

    getStepLabel(stepEl) {
      return stepEl?.dataset.filterLabel || '';
    }

    buildStepper() {
      if (!this.stepperList) return;
      this.stepperList.innerHTML = '';

      this.steps.forEach((step, index) => {
        const item = document.createElement('li');
        item.className = 'collection-filter-wizard__stepper-item';
        item.dataset.stepIndex = String(index);

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'collection-filter-wizard__stepper-trigger';
        trigger.disabled = true;

        const marker = document.createElement('span');
        marker.className = 'collection-filter-wizard__stepper-marker';
        marker.textContent = String(index + 1);

        const label = document.createElement('span');
        label.className = 'collection-filter-wizard__stepper-label';
        label.textContent = this.getStepLabel(step);

        trigger.appendChild(marker);
        trigger.appendChild(label);
        item.appendChild(trigger);
        this.stepperList.appendChild(item);
      });
    }

    hasStepSelection(stepIndex) {
      const step = this.steps[stepIndex];
      if (!step) return false;
      const cards = getStepCards(step);
      if (cards.some((c) => c.classList.contains('active'))) return true;
      return cards.some((card) => {
        const { param } = readCardSelection(card);
        return param && this.pending.has(param);
      });
    }

    updateStepper() {
      const items = this.stepperList
        ? Array.from(this.stepperList.querySelectorAll('.collection-filter-wizard__stepper-item'))
        : [];

      items.forEach((item, index) => {
        const trigger = item.querySelector('.collection-filter-wizard__stepper-trigger');
        const canNavigate = index !== this.currentStep;
        const hasSelection = this.hasStepSelection(index);
        const isComplete = index !== this.currentStep && hasSelection;
        const isPassed = index !== this.currentStep && index < this.currentStep && !hasSelection;

        item.classList.toggle('is-active', index === this.currentStep);
        item.classList.toggle('is-complete', isComplete);
        item.classList.toggle('is-passed', isPassed);
        item.classList.toggle('is-clickable', canNavigate);

        if (trigger) {
          trigger.disabled = !canNavigate;
          trigger.setAttribute('aria-current', index === this.currentStep ? 'step' : 'false');
        }
      });
    }

    goToStep(index) {
      if (index < 0 || index >= this.steps.length) return;
      if (index === this.currentStep) return;

      const activeStep = this.steps[this.currentStep];
      if (activeStep) this.clearStepPendingIfUnselected(activeStep);

      if (index < this.currentStep) {
        this.clearSelectionsAfterStep(index);
      }

      this.currentStep = index;
      this.syncMaxStepReachedFromSelections();
      this.renderStep();
    }

    seedPendingFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);

      this.steps.forEach((step) => {
        getStepCards(step).forEach((card) => {
          const { param, value } = readCardSelection(card);
          if (!param || value == null) return;

          const urlValues = urlParams.getAll(param);
          if (urlValues.includes(value)) {
            this.pending.set(param, value);
          }
        });
      });
    }

    bindEvents() {
      if (this.root.dataset.wizardEventsBound === 'true') return;
      this.root.dataset.wizardEventsBound = 'true';
      this.prevBtn?.addEventListener('click', () => this.goPrev());
      this.viewCompatibleBtn?.addEventListener('click', () => this.applyAll());
      this.nextBtn?.addEventListener('click', () => this.goNext());
      this.applyBtn?.addEventListener('click', () => this.applyAll());

      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });

      this.root.addEventListener('click', (e) => {
        if (this.root.hidden || !this.dialogEl) return;

        const clickPath = typeof e.composedPath === 'function' ? e.composedPath() : [];
        if (clickPath.includes(this.dialogEl) || this.dialogEl.contains(e.target)) return;

        this.close();
      });

      this.root.addEventListener('click', (e) => {
        const skipBtn = e.target.closest('[data-wizard-skip]');
        if (!skipBtn || !this.root.contains(skipBtn)) return;
        e.preventDefault();
        this.applyAll();
      });

      this.root.addEventListener('click', (e) => {
        const measureToggle = e.target.closest('[data-wizard-measure-toggle]');
        if (measureToggle && this.root.contains(measureToggle)) {
          e.preventDefault();
          e.stopPropagation();
          const measure = measureToggle.closest('[data-wizard-measure]');
          if (!measure) return;
          const willExpand = measure.classList.contains('is-collapsed');
          this.setMeasureExpanded(measure, willExpand);
          return;
        }
      });

      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });

      this.stepperList?.addEventListener('click', (e) => {
        const trigger = e.target.closest('.collection-filter-wizard__stepper-trigger');
        if (!trigger || trigger.disabled) return;
        const item = trigger.closest('.collection-filter-wizard__stepper-item');
        if (!item) return;
        const index = Number(item.dataset.stepIndex);
        if (!Number.isNaN(index)) this.goToStep(index);
      });

      this.root.addEventListener('click', (e) => {
        const card = e.target.closest('.collection-filter-wizard__step .custom-filter-card');
        if (!card || !this.root.contains(card)) return;
        e.preventDefault();
        this.handleCardClick(card);
      });

      this.root.addEventListener('keydown', (e) => {
        const card = e.target.closest('.collection-filter-wizard__step .custom-filter-card');
        if (!card || !this.root.contains(card)) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleCardClick(card);
        }
      });

      document.querySelectorAll('[data-wizard-open]').forEach((trigger) => {
        if (trigger.dataset.wizardTriggerBound === 'true') return;
        trigger.dataset.wizardTriggerBound = 'true';
        trigger.addEventListener('click', () => {
          this.open();
        });
      });

      this.onSidebarFacetChange = () => {
        if (this.root.hidden) return;
        this.updateSelectionSummary();
        this.scheduleCardAvailabilityUpdate();
      };

      this.selectionToggle?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!this.selectionEl) return;
        const willExpand = this.selectionEl.classList.contains('is-collapsed');
        this.setSelectionExpanded(willExpand);
      });

      this.selectionListEl?.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-wizard-selection-step]');
        if (!trigger || !this.selectionListEl.contains(trigger)) return;

        event.preventDefault();
        event.stopPropagation();

        const index = Number(trigger.dataset.wizardSelectionStep);
        if (Number.isNaN(index)) return;
        this.goToStep(index);
      });

      [document.getElementById('FacetFiltersForm'), document.getElementById('FacetFiltersFormMobile')].forEach(
        (form) => {
          if (!form || form.dataset.wizardFacetBound === 'true') return;
          form.dataset.wizardFacetBound = 'true';
          form.addEventListener('input', this.onSidebarFacetChange);
          form.addEventListener('change', this.onSidebarFacetChange);
        }
      );
    }

    markDialogLazyBackgrounds() {
      if (!this.dialogEl) return;
      this.dialogEl.querySelectorAll('div, section').forEach((el) => {
        el.classList.add('xbg');
      });
    }

    open(stepIndex, options = {}) {
      if (typeof stepIndex === 'number') {
        this.currentStep = stepIndex;
      }
      this.syncFromAppliedFilters({ preselectGoodman: options.preselectGoodman });
      if (options.preselectGoodman) {
        setPreselectGoodmanIntent(this);
      }
      this.maxStepReached = Math.max(this.maxStepReached, this.currentStep);
      this.root.hidden = false;
      this.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('collection-filter-wizard-open');
      this.renderStep();
      this.previousStepIndex = null;
      this.markDialogLazyBackgrounds();
      this.root.querySelector('.collection-filter-wizard__close')?.focus();
    }

    close(options = {}) {
      this.collapseAllMeasurePanels();
      this.root.hidden = true;
      this.root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('collection-filter-wizard-open');
      this.setSelectionExpanded(false);

      if (options.unlockPageScroll) {
        unlockPageScroll();
      }
    }

    setMeasureExpanded(measureEl, expanded) {
      if (!measureEl) return;
      const toggle = measureEl.querySelector('[data-wizard-measure-toggle]');
      const panel = measureEl.querySelector('[data-wizard-measure-panel]');
      if (!toggle || !panel) return;

      measureEl.classList.toggle('is-collapsed', !expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.hidden = !expanded;
    }

    collapseAllMeasurePanels() {
      this.root.querySelectorAll('[data-wizard-measure]').forEach((measure) => {
        this.setMeasureExpanded(measure, false);
      });
    }

    clearStepPendingIfUnselected(step) {
      if (!step || getActiveCardForStep(step)) return;

      const params = new Set();
      getStepCards(step).forEach((card) => {
        const { param } = readCardSelection(card);
        if (param) params.add(param);
      });

      params.forEach((param) => {
        const hasPendingSelection = getStepCards(step).some((card) => {
          const { param: cardParam, value } = readCardSelection(card);
          return cardParam === param && value != null && this.pending.get(param) === value;
        });
        if (!hasPendingSelection) {
          this.pending.delete(param);
        }
      });
    }

    clearStepSelections(step) {
      if (!step) return;

      getStepCards(step).forEach((card) => setCardActive(card, false));

      const params = new Set();
      getStepCards(step).forEach((card) => {
        const { param } = readCardSelection(card);
        if (param) params.add(param);
      });
      params.forEach((param) => this.pending.delete(param));
    }

    clearSelectionsAfterStep(stepIndex) {
      let changed = false;

      for (let i = stepIndex + 1; i < this.steps.length; i++) {
        const step = this.steps[i];
        const hadSelection = this.hasStepSelection(i);
        this.clearStepSelections(step);
        if (hadSelection) changed = true;
      }

      if (!changed) return;

      this.persistState();
      this.syncMaxStepReachedFromSelections();
      this.updateStepper();
      this.updateSelectionSummary();
    }

    updateNextButtonState() {
      if (this.nextBtn) {
        this.nextBtn.disabled = false;
      }

      if (this.applyBtn) {
        this.applyBtn.disabled = false;
      }
    }

    updateNavLabels() {
      const prevStep = this.steps[this.currentStep - 1];
      const nextStep = this.steps[this.currentStep + 1];

      if (this.prevLabelEl) {
        this.prevLabelEl.textContent = prevStep ? this.i18n.previousStep : '';
      }

      if (this.nextLabelEl) {
        if (!nextStep) {
          this.nextLabelEl.textContent = '';
          return;
        }

        const stepName = this.getStepLabel(nextStep);
        const namedTemplate = this.i18n.nextStepNamed || 'Next: __STEP__';
        this.nextLabelEl.textContent = namedTemplate.replace('__STEP__', stepName);
      }
    }

    syncSelectionPanelForStep() {
      if (!this.selectionEl || !this.selectionToggle) return;

      if (this.currentStep < 1) {
        this.setSelectionExpanded(false);
        this.previousStepIndex = this.currentStep;
        return;
      }

      const isLast = this.currentStep === this.steps.length - 1;
      const enteredLastStep =
        isLast &&
        this.previousStepIndex !== null &&
        this.previousStepIndex !== this.currentStep &&
        this.previousStepIndex < this.steps.length - 1;

      if (enteredLastStep) {
        this.setSelectionExpanded(true);
      }

      this.previousStepIndex = this.currentStep;
    }

    setSelectionExpanded(expanded) {
      if (!this.selectionEl || !this.selectionToggle) return;
      this.selectionEl.classList.toggle('is-collapsed', !expanded);
      this.selectionToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      const panel = this.root.querySelector('[data-wizard-selection-panel]');
      if (panel) {
        panel.hidden = !expanded;
      }
    }

    updateSelectionSummary() {
      if (!this.selectionEl || !this.selectionListEl) return;

      const showSummary = this.currentStep >= 1;
      const sidebarSelections = this.getActiveSidebarFacetSelections();

      if (!showSummary) {
        this.selectionEl.hidden = true;
        this.selectionListEl.innerHTML = '';
        this.updateCompatibleCount();
        return;
      }

      this.selectionListEl.innerHTML = '';

      const wizardSelections = this.steps
        .map((step) => ({
          step,
          card: getSelectedCardForStep(step, this.pending),
        }))
        .filter((entry) => entry.card);

      if (!sidebarSelections.length && !wizardSelections.length) {
        this.selectionEl.hidden = true;
        this.updateCompatibleCount();
        return;
      }

      this.selectionEl.hidden = false;

      sidebarSelections.forEach((selection) => {
        appendSelectionListItem(
          this.selectionListEl,
          buildTextSelectionValue(selection.displayValue),
          selection.label,
          'collection-filter-wizard__selection-item--sidebar'
        );
      });

      wizardSelections.forEach(({ step, card }) => {
        const stepIndex = this.steps.indexOf(step);
        const stepLabel = this.getStepLabel(step);
        const goToTemplate = this.i18n.selectionGoToStep || 'Go to __STEP__ step';

        appendSelectionListItem(
          this.selectionListEl,
          buildSelectionValue(card),
          stepLabel,
          '',
          {
            stepIndex,
            ariaLabel: goToTemplate.replace('__STEP__', stepLabel),
          }
        );
      });

      this.updateCompatibleCount();
      this.markDialogLazyBackgrounds();
    }

    getWizardFilterParamNames() {
      const params = new Set();
      this.steps.forEach((step) => {
        getStepCards(step).forEach((card) => {
          const param = card.dataset.filterParam;
          if (param) params.add(param);
        });
      });
      return params;
    }

    getActiveFacetForm() {
      const desktop = document.getElementById('FacetFiltersForm');
      const mobile = document.getElementById('FacetFiltersFormMobile');
      if (desktop && desktop.offsetParent !== null) return desktop;
      if (mobile && mobile.offsetParent !== null) return mobile;
      return desktop || mobile;
    }

    getFacetFormFilterParamKeys() {
      const keys = new Set();
      [document.getElementById('FacetFiltersForm'), document.getElementById('FacetFiltersFormMobile')].forEach(
        (form) => {
          if (!form) return;
          form.querySelectorAll('[name^="filter."]').forEach((el) => {
            const name = el.getAttribute('name');
            if (name) keys.add(name);
          });
        }
      );
      return keys;
    }

    getCheckedFacetFilterParams() {
      const params = new URLSearchParams();
      const form = this.getActiveFacetForm();
      if (!form) return params;

      form.querySelectorAll('[name^="filter."]').forEach((el) => {
        const name = el.getAttribute('name');
        if (!name || EXCLUDED_MERGE_FILTER_PARAMS.has(name)) return;

        if (el.type === 'checkbox' || el.type === 'radio') {
          if (!el.checked) return;
        } else if (!el.value) {
          return;
        }

        params.delete(name);
        params.append(name, el.value);
      });

      return params;
    }

    getActiveSidebarFacetSelections() {
      const wizardParams = this.getWizardFilterParamNames();
      const facetFormKeys = this.getFacetFormFilterParamKeys();
      const form = this.getActiveFacetForm();
      const selections = [];
      const seenParams = new Set();

      const addSelection = (param, displayValue) => {
        if (!param || EXCLUDED_MERGE_FILTER_PARAMS.has(param) || wizardParams.has(param)) return;
        if (!facetFormKeys.has(param)) return;
        if (seenParams.has(param)) return;
        seenParams.add(param);

        let filterLabel = '';
        let matchedInput = null;
        if (form) {
          form.querySelectorAll(`input[name="${param}"]`).forEach((candidate) => {
            if (candidate.value === displayValue) matchedInput = candidate;
          });
        }
        const details = matchedInput?.closest('.facets__disclosure-vertical, .mobile-facets__details, .js-filter');
        if (details) {
          const summaryLabel = details.querySelector(
            '.facets__summary-label, .mobile-facets__summary .facets__summary-label'
          );
          filterLabel = cleanFacetSummaryLabel(summaryLabel?.textContent || '');
        }

        const optionLabel = matchedInput?.closest('label')?.querySelector('.facet-checkbox__text-label');
        const resolvedValue = optionLabel?.textContent?.trim() || displayValue;

        if (!filterLabel) {
          filterLabel = param
            .replace(/^filter\.p\.m\.custom\./, '')
            .replace(/^filter\.p\./, '')
            .replace(/_/g, ' ');
        }

        selections.push({ param, label: filterLabel, displayValue: resolvedValue });
      };

      if (form) {
        form.querySelectorAll('input[name^="filter."][type="checkbox"]:checked').forEach((input) => {
          addSelection(input.getAttribute('name'), input.value);
        });
      }

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach((value, key) => {
        addSelection(key, value);
      });

      return selections;
    }

    buildMergedFilterSearchParams() {
      const wizardParams = this.getWizardFilterParamNames();
      const facetFormKeys = this.getFacetFormFilterParamKeys();
      const merged = new URLSearchParams();
      const urlParams = new URLSearchParams(window.location.search);

      urlParams.forEach((value, key) => {
        if (!key.startsWith('filter.')) {
          if (EXCLUDED_URL_PARAMS.has(key)) return;
          merged.append(key, value);
        }
      });

      this.getCheckedFacetFilterParams().forEach((value, key) => {
        if (EXCLUDED_MERGE_FILTER_PARAMS.has(key) || wizardParams.has(key)) return;
        merged.delete(key);
        merged.append(key, value);
      });

      urlParams.forEach((value, key) => {
        if (!key.startsWith('filter.')) return;
        if (EXCLUDED_MERGE_FILTER_PARAMS.has(key) || wizardParams.has(key)) return;
        if (facetFormKeys.has(key)) return;
        merged.append(key, value);
      });

      this.pending.forEach((value, param) => {
        merged.delete(param);
        merged.append(param, value);
      });

      return merged.toString();
    }

    buildCountSearchParams() {
      const merged = new URLSearchParams();
      const urlParams = new URLSearchParams(window.location.search);

      urlParams.forEach((value, key) => {
        if (!key.startsWith('filter.')) {
          if (EXCLUDED_URL_PARAMS.has(key)) return;
          merged.append(key, value);
        }
      });

      this.pending.forEach((value, param) => {
        merged.delete(param);
        merged.append(param, value);
      });

      return merged.toString();
    }

    getProductGridSectionId() {
      return document.getElementById('product-grid')?.dataset?.id || null;
    }

    shouldUseJsonForAvailability() {
      const settings = window.collectionJsonSectionSettings || {};
      if (settings.enable_product_grouping) return false;

      const products = this.getProductsForAvailability();
      return Boolean(products?.length && this.getAvailabilityRenderer());
    }

    parseCountFromSectionHtml(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const countEl =
        doc.getElementById('ProductCount') ||
        doc.getElementById('ProductCountDesktop') ||
        doc.querySelector('.product-count__text');
      if (!countEl) return null;
      return parseProductCount(countEl.textContent);
    }

    async fetchCountFromJson() {
      const loader = window._collectionJsonLoader;
      const productGrid = document.getElementById('product-grid');
      if (!loader?.isLoaded?.() || !productGrid || typeof CollectionProductRenderer === 'undefined') {
        return null;
      }

      const handle = productGrid.dataset.collectionHandle;
      if (!handle) return null;

      let products = loader.getProductsByHandle(handle);
      if (!products?.length) return 0;

      const params = new URLSearchParams(this.buildCountSearchParams());
      const filters = {};
      params.forEach((value, key) => {
        if (!key.startsWith('filter.')) return;
        const filterKey = key.slice(7);
        if (!filters[filterKey]) filters[filterKey] = [];
        filters[filterKey].push(value);
      });

      const renderer = new CollectionProductRenderer({
        container: productGrid,
        collectionHandle: handle,
        jsonLoader: loader,
        sectionSettings: window.collectionJsonSectionSettings || {},
      });

      products = renderer.applyFilters(products, filters);
      return products.length;
    }

    setCompatibleCountLoading(isLoading) {
      if (!this.selectionCountEl) return;
      this.selectionCountEl.classList.toggle('is-loading', isLoading);
      if (isLoading) {
        this.selectionCountEl.hidden = false;
        this.selectionCountEl.textContent = this.i18n.compatibleCountLoading;
      }
    }

    setCompatibleCountValue(count) {
      if (!this.selectionCountEl) return;
      this.selectionCountEl.classList.remove('is-loading');
      this.selectionCountEl.hidden = false;
      const template =
        count === 1 ? this.i18n.compatibleCountOne : this.i18n.compatibleCountOther;
      this.selectionCountEl.textContent = formatCountLabel(template, count);
    }

    hideCompatibleCount() {
      if (!this.selectionCountEl) return;
      this.selectionCountEl.classList.remove('is-loading');
      this.selectionCountEl.hidden = true;
      this.selectionCountEl.textContent = '';
    }

    updateCompatibleCount() {
      if (!this.selectionCountEl) return;

      if (this.currentStep < 1 || this.pending.size === 0) {
        this.hideCompatibleCount();
        return;
      }

      this.scheduleCompatibleCountFetch();
    }

    async fetchCompatibleCount() {
      if (this.currentStep < 1) {
        this.hideCompatibleCount();
        return;
      }

      const hasWizardSelection = this.pending.size > 0;
      const hasSidebarSelection = this.getActiveSidebarFacetSelections().length > 0;

      if (!hasWizardSelection && !hasSidebarSelection) {
        this.hideCompatibleCount();
        return;
      }

      const sectionId = this.getProductGridSectionId();
      const requestId = ++this.countFetchRequestId;

      if (this.countFetchAbortController) {
        this.countFetchAbortController.abort();
      }
      this.countFetchAbortController = new AbortController();

      this.setCompatibleCountLoading(true);

      try {
        let count = null;

        if (sectionId) {
          const searchParams = this.buildCountSearchParams();
          const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
          const response = await fetch(url, { signal: this.countFetchAbortController.signal });
          if (response.ok) {
            const html = await response.text();
            count = this.parseCountFromSectionHtml(html);
          }
        }

        if (count == null) {
          count = await this.fetchCountFromJson();
        }

        if (requestId !== this.countFetchRequestId) return;

        if (count == null) {
          this.hideCompatibleCount();
          return;
        }

        this.setCompatibleCountValue(count);
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (requestId !== this.countFetchRequestId) return;
        this.hideCompatibleCount();
      }
    }

    getStepFilterParams(stepEl) {
      const params = new Set();
      getStepCards(stepEl).forEach((card) => {
        const { param } = readCardSelection(card);
        if (param) params.add(param);
      });
      return params;
    }

    buildFilterParamsObject(excludeParams = []) {
      const excludeSet = new Set(excludeParams.filter(Boolean));
      const filters = {};

      const addFilter = (param, value) => {
        if (!param || value == null || excludeSet.has(param)) return;
        if (EXCLUDED_MERGE_FILTER_PARAMS.has(param)) return;
        const filterKey = param.startsWith('filter.') ? param.slice(7) : param;
        filters[filterKey] = [String(value).trim()];
      };

      this.getCheckedFacetFilterParams().forEach((value, key) => {
        if (this.getWizardFilterParamNames().has(key)) return;
        addFilter(key, value);
      });

      this.pending.forEach((value, param) => {
        addFilter(param, value);
      });

      return filters;
    }

    buildAvailabilitySearchParams(excludeParams = []) {
      const merged = new URLSearchParams();
      const urlParams = new URLSearchParams(window.location.search);
      const excludeSet = new Set(excludeParams.filter(Boolean));
      const wizardParams = this.getWizardFilterParamNames();

      urlParams.forEach((value, key) => {
        if (!key.startsWith('filter.')) {
          if (EXCLUDED_URL_PARAMS.has(key)) return;
          merged.append(key, value);
        }
      });

      this.getCheckedFacetFilterParams().forEach((value, key) => {
        if (excludeSet.has(key) || EXCLUDED_MERGE_FILTER_PARAMS.has(key) || wizardParams.has(key)) return;
        merged.delete(key);
        merged.append(key, value);
      });

      this.pending.forEach((value, param) => {
        if (excludeSet.has(param)) return;
        merged.delete(param);
        merged.append(param, value);
      });

      return merged.toString();
    }

    getProductsForAvailability() {
      const loader = window._collectionJsonLoader;
      const productGrid = document.getElementById('product-grid');
      if (!loader?.isLoaded?.() || !productGrid) return null;

      const handle = productGrid.dataset.collectionHandle;
      if (!handle) return null;

      return loader.getProductsByHandle(handle);
    }

    getAvailabilityRenderer() {
      if (this._availabilityRenderer) return this._availabilityRenderer;

      const productGrid = document.getElementById('product-grid');
      const loader = window._collectionJsonLoader;
      if (!productGrid || !loader || typeof CollectionProductRenderer === 'undefined') return null;

      this._availabilityRenderer = new CollectionProductRenderer({
        container: productGrid,
        collectionHandle: productGrid.dataset.collectionHandle,
        jsonLoader: loader,
        sectionSettings: window.collectionJsonSectionSettings || {},
      });

      return this._availabilityRenderer;
    }

    isCardAvailableViaJson(card, excludeParams) {
      const products = this.getProductsForAvailability();
      const renderer = this.getAvailabilityRenderer();
      if (!products?.length || !renderer) return null;

      const { param, value } = readCardSelection(card);
      if (!param || value == null) return true;

      const filters = this.buildFilterParamsObject(excludeParams);
      const filterKey = param.startsWith('filter.') ? param.slice(7) : param;
      filters[filterKey] = [String(value).trim()];

      return renderer.applyFilters(products, filters).length > 0;
    }

    parseFacetAvailabilityFromHtml(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const map = new Map();

      [doc.getElementById('FacetFiltersForm'), doc.getElementById('FacetFiltersFormMobile')]
        .filter(Boolean)
        .forEach((form) => {
          form.querySelectorAll('input[name^="filter."]').forEach((input) => {
            if (input.type !== 'checkbox' && input.type !== 'radio') return;

            const name = input.getAttribute('name');
            const value = input.value;
            if (!name || value == null) return;

            const key = `${name}::${value}`;
            const label = input.closest('label');
            const disabled = input.disabled || label?.classList.contains('disabled');
            if (!map.has(key) || !disabled) {
              map.set(key, !disabled);
            }
          });
        });

      return map;
    }

    pruneUnavailableSelections() {
      let changed = false;
      const preserveGoodman = shouldPreselectGoodman(this);

      this.steps.forEach((step) => {
        getStepCards(step).forEach((card) => {
          if (!card.classList.contains('is-unavailable')) return;
          if (preserveGoodman && findGoodmanBrandCard(step) === card) return;

          const { param, value } = readCardSelection(card);
          const isSelected =
            card.classList.contains('active') || (param && this.pending.get(param) === value);

          if (!isSelected) return;

          setCardActive(card, false);
          if (param) {
            this.pending.delete(param);
            changed = true;
          }
        });
      });

      if (!changed) return;

      this.persistState();
      this.syncMaxStepReachedFromSelections();
      this.updateStepper();
      this.updateSelectionSummary();
    }

    validateAllPendingSelectionsViaJson() {
      if (!this.shouldUseJsonForAvailability()) return false;

      const products = this.getProductsForAvailability();
      const renderer = this.getAvailabilityRenderer();
      if (!products?.length || !renderer) return false;

      let changed = false;

      this.pending.forEach((value, param) => {
        const filters = this.buildFilterParamsObject([param]);
        const filterKey = param.startsWith('filter.') ? param.slice(7) : param;
        filters[filterKey] = [String(value).trim()];

        if (renderer.applyFilters(products, filters).length === 0) {
          this.pending.delete(param);
          changed = true;
        }
      });

      if (!changed) return false;

      this.syncCardsFromPending();
      this.persistState();
      this.syncMaxStepReachedFromSelections();
      this.updateStepper();
      this.updateSelectionSummary();
      return true;
    }

    getStepCardsWrap(stepEl) {
      return stepEl?.querySelector('.custom-filter-cards--wizard, .custom-filter-cards') || null;
    }

    ensureStepOptionsLoader(stepEl) {
      let loader = stepEl.querySelector('.collection-filter-wizard__options-loader');
      if (loader) return loader;

      const cardsWrap = this.getStepCardsWrap(stepEl);
      if (!cardsWrap) return null;

      loader = document.createElement('div');
      loader.className = 'collection-filter-wizard__options-loader';
      loader.hidden = true;
      loader.innerHTML = `
        <span class="collection-filter-wizard__options-loader-spinner" aria-hidden="true"></span>
        <span class="collection-filter-wizard__options-loader-text"></span>
      `;
      loader.querySelector('.collection-filter-wizard__options-loader-text').textContent =
        this.i18n.optionsLoading;
      cardsWrap.insertAdjacentElement('afterend', loader);
      return loader;
    }

    setStepOptionsLoaderVisible(stepEl, isVisible) {
      const loader = this.ensureStepOptionsLoader(stepEl);
      if (!loader) return;
      loader.hidden = !isVisible;
    }

    updateStepEmptyState(stepEl) {
      const cardsWrap = this.getStepCardsWrap(stepEl);
      if (!cardsWrap) return;

      const visibleCards = getStepCards(stepEl).filter((card) => !card.classList.contains('is-unavailable'));
      let emptyEl = stepEl.querySelector('.collection-filter-wizard__options-empty');

      if (visibleCards.length === 0) {
        if (!emptyEl) {
          emptyEl = document.createElement('p');
          emptyEl.className = 'collection-filter-wizard__options-empty';
          emptyEl.textContent = this.i18n.optionsEmpty;
          const loader = stepEl.querySelector('.collection-filter-wizard__options-loader');
          if (loader) {
            loader.insertAdjacentElement('afterend', emptyEl);
          } else {
            cardsWrap.insertAdjacentElement('afterend', emptyEl);
          }
        }
        emptyEl.hidden = false;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
    }

    resetInactiveStepOptions() {
      this.steps.forEach((step, index) => {
        if (index === this.currentStep) return;

        const cardsWrap = this.getStepCardsWrap(step);
        cardsWrap?.classList.remove('is-options-ready');

        const loader = step.querySelector('.collection-filter-wizard__options-loader');
        if (loader) loader.hidden = true;

        const emptyEl = step.querySelector('.collection-filter-wizard__options-empty');
        if (emptyEl) emptyEl.hidden = true;
      });
    }

    async runCardAvailabilityUpdate(step, requestId) {
      const excludeParams = Array.from(this.getStepFilterParams(step));
      const cards = getStepCards(step);
      if (!cards.length) return;

      cards.forEach((card) => setCardUnavailable(card, false));

      if (this.shouldUseJsonForAvailability()) {
        this.validateAllPendingSelectionsViaJson();
        cards.forEach((card) => {
          const available = this.isCardAvailableViaJson(card, excludeParams);
          setCardUnavailable(card, available === false);
        });
        return;
      }

      const sectionId = this.getProductGridSectionId();
      if (!sectionId) {
        cards.forEach((card) => setCardUnavailable(card, false));
        this.pruneUnavailableSelections();
        return;
      }

      const searchParams = this.buildAvailabilitySearchParams(excludeParams);
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      const response = await fetch(url);
      if (!response.ok) {
        cards.forEach((card) => setCardUnavailable(card, false));
        return;
      }
      if (requestId !== this.availabilityFetchRequestId) return;

      const map = this.parseFacetAvailabilityFromHtml(await response.text());
      cards.forEach((card) => {
        const { param, value } = readCardSelection(card);
        const key = `${param}::${value}`;
        const available = map.has(key) ? map.get(key) : true;
        setCardUnavailable(card, !available);
      });
    }

    async refreshStepOptions() {
      const step = this.steps[this.currentStep];
      if (!step || this.root.hidden) return;

      const cardsWrap = this.getStepCardsWrap(step);
      cardsWrap?.classList.remove('is-options-ready');

      const emptyEl = step.querySelector('.collection-filter-wizard__options-empty');
      if (emptyEl) emptyEl.hidden = true;

      const requestId = ++this.availabilityFetchRequestId;
      let loaderShown = false;
      const loaderTimer = setTimeout(() => {
        if (requestId !== this.availabilityFetchRequestId) return;
        loaderShown = true;
        this.setStepOptionsLoaderVisible(step, true);
      }, 80);

      try {
        await this.runCardAvailabilityUpdate(step, requestId);
        if (requestId !== this.availabilityFetchRequestId) return;

        this.pruneUnavailableSelections();
        this.updateNextButtonState();
      } catch (error) {
        if (requestId !== this.availabilityFetchRequestId) return;

        getStepCards(step).forEach((card) => setCardUnavailable(card, false));
      } finally {
        clearTimeout(loaderTimer);
        if (requestId !== this.availabilityFetchRequestId) return;
        if (this.steps[this.currentStep] !== step) return;

        if (loaderShown) this.setStepOptionsLoaderVisible(step, false);
        cardsWrap?.classList.add('is-options-ready');
        this.updateStepEmptyState(step);
      }
    }

    async updateCardAvailability() {
      await this.refreshStepOptions();
    }

    renderStep() {
      this.syncCardsFromPending();
      this.resetInactiveStepOptions();

      this.steps.forEach((step, i) => {
        step.classList.toggle('is-active', i === this.currentStep);
      });

      this.updateStepper();

      const isFirst = this.currentStep === 0;
      const isLast = this.currentStep === this.steps.length - 1;

      if (this.footerEl) {
        this.footerEl.classList.toggle('is-first-step', isFirst);
        this.footerEl.classList.toggle('is-last-step', isLast);
        this.footerEl.classList.toggle('is-middle-step', !isFirst && !isLast);
      }

      if (this.prevBtn) {
        this.prevBtn.hidden = isFirst;
      }

      if (this.nextBtn) {
        this.nextBtn.hidden = isLast;
        this.nextBtn.setAttribute('aria-hidden', isLast ? 'true' : 'false');
      }

      const isMiddle = !isFirst && !isLast;
      const hasPartialSelections =
        this.pending.size > 0 || this.getActiveSidebarFacetSelections().length > 0;

      if (this.viewCompatibleBtn) {
        this.viewCompatibleBtn.hidden = !isMiddle;
        this.viewCompatibleBtn.setAttribute('aria-hidden', isMiddle ? 'false' : 'true');
        this.viewCompatibleBtn.disabled = !hasPartialSelections;
      }

      if (this.applyBtn) {
        this.applyBtn.hidden = !isLast;
        this.applyBtn.setAttribute('aria-hidden', isLast ? 'false' : 'true');
      }

      const activeStep = this.steps[this.currentStep];
      if (activeStep) {
        const titleEl = activeStep.querySelector('.collection-filter-wizard__step-title');
        const dialogEl = this.root.querySelector('.collection-filter-wizard__dialog');
        if (titleEl && dialogEl) {
          const titleId = `collection-filter-wizard-step-title-${this.currentStep}`;
          titleEl.id = titleId;
          dialogEl.setAttribute('aria-labelledby', titleId);
        }
      }

      this.updateNavLabels();
      this.updateNextButtonState();
      this.updateSelectionSummary();
      this.syncSelectionPanelForStep();
      this.syncMeasurePanelsForStep();
      this.refreshStepOptions();
    }

    syncMeasurePanelsForStep() {
      this.root.querySelectorAll('[data-wizard-measure]').forEach((measure) => {
        const step = measure.closest('.collection-filter-wizard__step');
        if (!step) return;
        const stepIndex = this.steps.indexOf(step);
        this.setMeasureExpanded(measure, stepIndex === this.currentStep);
      });
    }

    goPrev() {
      if (this.currentStep > 0) {
        this.goToStep(this.currentStep - 1);
      }
    }

    goNext() {
      const activeStep = this.steps[this.currentStep];
      if (activeStep) this.clearStepPendingIfUnselected(activeStep);

      if (this.currentStep < this.steps.length - 1) {
        this.currentStep += 1;
        this.maxStepReached = Math.max(this.maxStepReached, this.currentStep);
        this.renderStep();
      }
    }

    applyAll() {
      const activeStep = this.steps[this.currentStep];
      if (activeStep) this.clearStepPendingIfUnselected(activeStep);

      const queryString = this.buildMergedFilterSearchParams();
      clearPreselectGoodmanIntent(this);
      this.persistState();
      this.close({ unlockPageScroll: true });

      if (canRenderCollectionViaFacets()) {
        const onRendered = () => {
          document.removeEventListener('facetFilters:rendered', onRendered);
          unlockPageScroll();
          this.scrollToProductGrid();
        };
        document.addEventListener('facetFilters:rendered', onRendered);
        FacetFiltersForm.renderPage(queryString, null, true);
      } else {
        window.location.href = queryString
          ? `${window.location.pathname}?${queryString}`
          : window.location.pathname;
      }
    }
  }

  function initCollectionFilterWizard() {
    maybeFallbackGoodmanVendorFilter();

    const root = getWizardRoot();
    if (!root) return;

    if (root.collectionFilterWizard) {
      const wizard = root.collectionFilterWizard;
      const wasOpen = !wizard.root.hidden;
      wizard.syncFromAppliedFilters();
      if (wasOpen || shouldPreselectGoodman(wizard)) {
        wizard.renderStep();
      }
      return;
    }

    root.collectionFilterWizard = new CollectionFilterWizard(root);
  }

  document.addEventListener('DOMContentLoaded', initCollectionFilterWizard);
  document.addEventListener('facetFilters:rendered', initCollectionFilterWizard);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(initCollectionFilterWizard, 0);
  }
})();
